import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            CostoVariable {
              readAllByEmisor(emisor: $emisor) {
                _id
                nombre
                descripcion
                cuentaContable
                costoUnitarioTotal
                unidadMedida {
                  id
                  value
                  annotation
                }
                codigoMoneda {
                  id
                }
                codigo
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.CostoVariable.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: CostoVariableInput!) {
            CostoVariable {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.CostoVariable.create),

  delete: (_idEmisor, input) =>
    api
      .send({
        query: gql`
          mutation delete($_idEmisor: ID!, $input: [ID!]!) {
            CostoVariable {
              delete(_idEmisor: $_idEmisor, input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { _idEmisor, input }
      })
      .then(result => result.data.data.CostoVariable.delete)
}
